export class SearchDuplicateFileCriteria {
    endDate?: string;
    startDate?: string;
  
    SearchReportCriteria(): void {
      this.endDate = "";
      this.startDate = "";
    }
  }